// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__2Ce79","primary":"Button_primary__10Br9","danger":"Button_danger__lSpB4","greyed":"Button_greyed__1Va7j","link":"Button_link__1rCxA"};